export default __webpack_public_path__ + "static/media/kartu-4.14a524bd.jpg";